export function emitEvent(name, payload) {
  console.log('[EVENT]', name, payload);
  // En el futuro podríamos enviar estos datos a un backend vía HTTP o WebSocket.
}
